import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderLinkingRequestsInput } from './GetOrderLinkingRequestsInput';
import { GetOrderLinkingRequestsOutput } from './GetOrderLinkingRequestsOutput';

export class GetOrderLinkingRequestsService extends HttpServiceBase {

  handle = (input?: GetOrderLinkingRequestsInput): Promise<Result<GetOrderLinkingRequestsOutput> | null> => {
    const promise = this.http.get<Result<GetOrderLinkingRequestsOutput>>(`${this.baseUrlSislogApi}/v2/recipe-by-product/order-linking-requests/${input?.orderId}`);
    return promise;
  }
}